<template>
  <v-card id="suitable-contractor-company">
    <list-contractor-company filter="suitable"></list-contractor-company>
  </v-card>
</template>

<script>
import listContractorCompany from "./list-contractor-company.view.vue";

export default {
  components: {
    listContractorCompany
  }
};
</script>

<style lang="scss">
#suitable-contractor-company .v-toolbar__content {
  padding: 14px;
}
</style>
